<template>
  <div class="home">
    <Header></Header>
    <div class="content" :style="{
      'margin-left': innerWidth > 1500 ? (innerWidth - 1500) / 2 + 'px' : '0px',
      'height': (innerHeight - 70 - 68) + 'px'
    }">
      <div style="margin-top: 30px;">
        <Banner></Banner>
      </div>

      <div style="margin-top: 50px;height: 70px;line-height: 70px;">
        <div style="" class="container_title fl">推荐课程</div>
        <div class="fr">
          <el-input placeholder="搜索您感兴趣的课程" v-model="goodName">
            <i slot="prefix" style="font-size: 14px;" @click="selectGoods()" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
      </div>
      <div class="tabScroll fl" v-for="(item, index) in typeList" :key="index">
        <div class="tabList">
          <div class="tabItem " @click="switchType(item)"
            :class="curTypeId == item.examCategoryId ? 'active' : 'un_active'">
            {{ item.name }}
          </div>
        </div>
      </div>
      <div style="margin-top: 10px; min-height: 180px;width: 100%;clear: both;">
        <div v-for="(good, i) in showGoodList" class="fl" :key="i" @click="goGoodDetail(good.goodsId)">
          <div class="good" style="width: 250px;padding: 10px;margin-top: 20px;margin-left: 10px;">
            <el-image style="width: 250px; border-radius: 10px;" :src="good.photos[0].url">
            </el-image>
            <div style="min-height: 50px;">
              <div class="w100p over_2">{{ good.goodsName }}</div>
              <div style="color: #c8c9cc;height: 50px;line-height: 50px;">
                <span><i class="el-icon-s-custom" style="font-size: 15px;"></i> {{ good.virtualBuyNum }}人在学</span>
                <span class="fr cdeeporange">￥{{ (good.costPrice / 100).toFixed(2) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style="margin-top: 70px;height: 70px;line-height: 70px;clear: both;">
        <div style="" class="container_title">福利班型</div>
      </div>
      <div style="margin-top: 10px; min-height: 180px;width: 100%;clear: both;">
        <div v-for="(good, i) in welfareGoodList" class="fl" :key="i" @click="goGoodDetail(good.goodsId)">
          <div class="good" style="width: 250px;padding: 10px;margin-top: 20px;margin-left: 10px;">
            <el-image style="width: 250px; border-radius: 10px;" :src="good.photos[0].url">
            </el-image>
            <div style="min-height: 50px;">
              <div class="w100p over_2">{{ good.goodsName }}</div>
              <div style="color: #c8c9cc;height: 50px;line-height: 50px;">
                <span><i class="el-icon-s-custom" style="font-size: 15px;"></i> {{ good.virtualBuyNum }}人在学</span>
                <span class="fr cdeeporange">￥{{ (good.costPrice / 100).toFixed(2) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style="margin-top: 80px;height: 70px;line-height: 70px;clear: both;">
        <div class="container_title">
          名师推荐
          <div class="fr" @click="goTeacherList"
            style="font-size: 16px;font-weight: 300; color: #737780;cursor: pointer;">
            查看更多<span class="el-icon-arrow-right"></span>
          </div>
        </div>

      </div>

      <div style="margin-top: 20px; min-height: 180px;width: 100%;">

        <div class="teacher fl " v-for="(o, index) in teacherList" :key="index"
          style="margin-left: 60px;padding: 10px;margin-top: 60px;" @click="goTeacherDetail(o.teacherId)">

          <div :class="`color-${index % 2}`"
            style="height: 330px;width: 280px; border-radius: 10px;border-top-left-radius:80px;">
            <img style="width: 170px;margin-top: -60px;margin-left: 50px; z-index: 99;position: relative;"
              :src="o.portraitUrl">
            <img
              style=" width: 270px;margin-top: -100px; border-radius: 10px;z-index: 99;position: relative;margin-left: 10px;"
              src="../../static/image/teacher/teacher-white.png">

            <div style="width: 100%;margin-top: -200px;z-index: 999;position: relative;">
              <div
                style="text-align: center;width: 100%;height: 50px;line-height: 50px;font-size: 23px;font-weight: 600;font-size: 25px;">
                {{ o.name }}</div>
              <div class="teacher-infos">
                {{ o.intro }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <Suspension></Suspension>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/common/Header"
import Banner from "../components/common/Banner"
import Footer from "../components/common/Footer"
import Suspension from "../components/common/Suspension"

import {
  getByUrl,
  getByParam
} from '@/api/api.js';

export default {
  name: "Home",
  components: {
    Header,
    Footer,
    Banner,
    Suspension
  },
  data() {
    return {
      typeList: [],
      showGoodList: [],
      welfareGoodList: [],
      curTypeId: '',
      goodName: '',
      industryCategoryId: '',
      examCategoryId: '',
      categoryDataList: [],
      data: [],
      innerWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
      innerHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
    }
  },
  mounted() {
    this.getGoodsData()
    this.getWelfareGoods()
    this.recommendTeacherList()
  },
  methods: {
    goGoodDetail(id) {
      this.$router.push({
        path: '/good/det',
        query: {
          id: id
        }
      })
    },
    goTeacherDetail(id) {
      this.$router.push({
        path: '/teacher/det',
        query: {
          id: id
        }
      })
    },
    goTeacherList() {
      this.$router.push({
        path: '/teacher'
      })
    },
    toGood(id) {
      this.$router.push({
        path: '/goods',
        query: {
          id: id
        }
      })
    },
    switchType(good) {
      this.curTypeId = good.examCategoryId
      this.showGoodList = good.goodsList
    },
    recommendTeacherList() {
      getByUrl('/web/teacher/recommendList/' + 4).then(res => {
        console.log(res)
        this.teacherList = res.data
      })
    },
    getWelfareGoods() {
      let params = {
        pageNum: 1,
        pageSize: 20,
        welfare: true
      }
      getByParam('/web/examCategoryGood/page', params).then(res => {
        console.log(res)
        this.welfareGoodList = res.data.pageInfo.list
      })
    },
    getGoodsData() {
      getByUrl('/web/examCategory/goodList').then(res => {
        console.log(res)
        this.data = res.data
        for (let i = 0; i < res.data.length; i++) {
          this.typeList.push(res.data[i])
        }
        this.curTypeId = this.typeList[0].examCategoryId
        this.showGoodList = this.typeList[0].goodsList
      })
    },
    selectGoods() {
      console.log(123)


    }

  }
}
</script>

<style scoped>
.el-select .el-input {
  width: 130px;
}

.input-with-select {
  height: 50px;
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}

.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}

.image {
  width: 100%;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.card-container {
  position: relative;
  width: 100%;
  overflow: hidden;
  /* 可选：添加滚动条样式 */
  /* scrollbar-width: thin; */
  /* scrollbar-color: #409eff #f0f0f0; */
}

.good:hover {
  background-color: #fff;
  transform: scale(1.1);
  /* 放大1.1倍 */
  border-radius: 10px;
}


.teacher:hover {
  background-color: #fff;
  transform: scale(1.1);
/* 放大1.1倍 */
 border-radius: 10px;
}


.teacher-infos {
  width: 230px;
  margin-left: 20px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  overflow: hidden;
  -webkit-box-orient: vertical;
}

.color-0 {
  background: linear-gradient(217.1deg, #04ccc1, #5de9e1 102.07%);
}

.color-1 {
  background: linear-gradient(215.84deg, #4a90e9, #6dc0ff 101.29%);
  ;
}

.color-2 {
  background-color: green;
}

.tabScroll {
  overflow: hidden;

}

.tabList {
  display: flex;
  transition: transform .3s;
  width: 96%;
  margin-left: 2%;
  margin-top: 20px;
}

.active {
  position: relative;
  background: rgba(5, 193, 183, .1);
  color: #399df6;
  font-weight: 600;
  font-size: 14px;
}

.un_active {
  position: relative;
  background: #EDEFF2;
  color: #737780;
  font-weight: 300;
}

.tabList .tabItem {
  padding: 6px 16px;
  border-radius: 15px;
  height: auto;
  line-height: 16px;
  font-size: 14px;
  margin-right: 15px;
  cursor: pointer;
  flex-shrink: 0;
}


.container_title {
  font-size: 32px;
  font-weight: 600;
  color: #2B2E33;
}
</style>